import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { IntegrationThemes } from '@cashier/cashier-model';

import { AlternativeCopyableText } from './alternative';
import { StandardCopyableText } from './standard';

interface CopyableTextProperties {
  name: string;
  text: string;
  label: string;
  theme: IntegrationThemes;
  type: 'standard' | 'qrCode' | 'alternative';
}

export const CopyableText = ({
  name,
  label,
  text,
  theme,
  type,
}: CopyableTextProperties): ReactElement => {
  const { t } = useTranslation();

  const isAlternativeCopyableTextUsed =
    type === 'alternative' && ['memo', 'destination'].includes(name);

  return isAlternativeCopyableTextUsed ? (
    <AlternativeCopyableText
      label={label}
      text={text}
      warningMessage={t('memoOrDestination.hint.message')}
    />
  ) : (
    <StandardCopyableText
      label={label}
      theme={theme}
      text={text}
      showQrCode={type === 'qrCode'}
    />
  );
};
